import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  cardExaminadoresCandidatos: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(3),
    width: '50%',
    [theme.breakpoints.down('sm')]: {
      width: '90%',
    },
  },
  dividerTitle: {
    marginBottom: theme.spacing(2),
  },
  item: {
    padding: theme.spacing(1, 0),
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: theme.spacing(2),
  },
  button: {
    margin: theme.spacing(1),
  },
  corpoModal: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  uploadContent: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  deleteButton: {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.error.contrastText,
    '&:hover': {
      backgroundColor: theme.palette.error.dark,
    },
  },
  buttonProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
}))
export default useStyles
